import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltyCheckReportContext } from '../novelty-check-report-context';
import { NoveltyCheckReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';
import { NoveltyCheckReportTitleService, RetrievalElementsService, TechFeaturesService } from '../../retrieval-result-report-service';
import { ComplexRetrievalService } from '../../complex-retrieval-service';
import { NoveltyCheckTaskStatusService } from '../../task-status-service';
import { SummaryTechFeaturesService } from '../../summary-tech-features-service';

@injectable()
export class PatentConfirmState implements NoveltyCheckReportState {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
        @inject(SummaryTechFeaturesService)
        private readonly _summaryTechFeatureService: SummaryTechFeaturesService,
        @inject(NoveltyCheckReportTitleService)
        private readonly _noveltyCheckReportTitleService: NoveltyCheckReportTitleService,
        @inject(TechFeaturesService)
        private readonly _techFeaturesService: TechFeaturesService,
        @inject(ComplexRetrievalService)
        private readonly _complexRetrievalService: ComplexRetrievalService,
        @inject(RetrievalElementsService)
        private readonly _retrievalElementsService: RetrievalElementsService,
        @inject(NoveltyCheckTaskStatusService)
        private readonly _noveltyCheckTaskStatusService: NoveltyCheckTaskStatusService,
    ) { }

    async enter(): Promise<void> {
        // 更新任务状态
        this._noveltyCheckTaskStatusService.pullTaskStatus();
        // 进入<专利确认>状态的逻辑
        this._logger.info('进入<专利确认>状态');
        this._switchTaskStep(NoveltyCheckTaskStep.PATENT_CONFIRM);
        this._complexRetrievalService.search();
        await Promise.all([
            // this._summaryTechFeatureService.pullSummary(),
            // 获取新颖性报告名称
            // this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle(),
            // 获取技术特征
            // this._techFeaturesService.pullTechFeatures(),
            // 获取搜索结果
            // this._complexRetrievalService.search(),
            // 获取检索要素
            this._retrievalElementsService.pullRetrievalElements(),
        ]);
    }

    async handleNext(context: NoveltyCheckReportContext): Promise<void> {
        await this._actionsBeforeNext();
        // 从<专利确认>状态进入特征对比表生成状态
        const generateFeatureCompareTableState = context.getState(NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE);
        await context.transitionTo(generateFeatureCompareTableState);
    }

    async handlePrevious(context: NoveltyCheckReportContext): Promise<void> {
        // 返回检索要素识别状态
        const retrievalElementState = context.getState(NoveltyCheckTaskStep.NOVELTY_SEARCH_RETRIEVAL_ELEMENTS);
        await context.transitionTo(retrievalElementState);
    }

    private async _actionsBeforeNext() {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE;
            return state;
        });
    }

    private _switchTaskStep(step: NoveltyCheckTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }
}
